import { motion } from 'framer-motion';
// Styling

import { Circle, CircleCheck } from 'lucide-react';

export type PasswordValidationProps = {
    isEightChar: boolean;
    isNumAndCap: boolean;
    isSpecialChar: boolean;
}

export default function PasswordValidationMessage({ isEightChar, isNumAndCap, isSpecialChar }: PasswordValidationProps) {

    return (
        <motion.div
            initial={{ opacity: 0, y: -40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            exit={{ opacity: 0, y: -40 }}
            className="flex w-full flex-col gap-1"
        >
            <span className="text-sm text-left">Craft a strong password, including:</span>
            <div
                className={`flex flex-row gap-2 text-sm transition-all duration-200 ${isEightChar ? 'text-primary line-through' : 'text-destructive'}`}
            >
                {!isEightChar ? (
                    <Circle className="stroke-destructive" size={20} />
                ) : (
                    <CircleCheck className="stroke-primary" size={20} />
                )}
                8 characters or more
            </div>
            <div
                className={`flex flex-row gap-2 text-sm transition-all duration-200 ${isNumAndCap ? 'text-primary line-through' : 'text-destructive'}`}
            >
                {!isNumAndCap ? (
                    <Circle className="stroke-destructive" size={20} />
                ) : (
                    <CircleCheck className="stroke-primary" size={20} />
                )}
                One number and one capital letter
            </div>

            <div
                className={`flex flex-row gap-2 text-sm transition-all duration-200 ${isSpecialChar ? 'text-primary line-through' : 'text-destructive'}`}
            >
                {!isSpecialChar ? (
                    <Circle className="stroke-destructive" size={20} />
                ) : (
                    <CircleCheck className="stroke-primary" size={20} />
                )}
                A special character
            </div>
        </motion.div>
    );
}
